module.exports = __webpack_public_path__ + "static/media/Thumbs.cbb85a7e.db";